export const constants = Object.freeze({
  // EXPERIENCE_CONTENT_BASE_URL: 'http://localhost:8888/elkfalls/content-package',
  // EXPERIENCE_CONTENT_BASE_URL: 'http://localhost:8888/polygons/content-package',
  // EXPERIENCE_CONTENT_BASE_URL: 'http://localhost:8888/map-testing/content-package',
  // EXPERIENCE_CONTENT_BASE_URL: 'https://hazel-web.clearcove.ca/elkfalls/content-package',
  EXPERIENCE_CONTENT_BASE_URL: 'https://hazel-web.clearcove.ca/wewaikai/content-package',
  // EXPERIENCE_CONTENT_BASE_URL: 'https://fniscak.ca/elkfalls/content-package',
  // js to detect current URL and append /content-package
  // fully selfcontained
  // only relative references to any asset
  // content elkfalls should run anywhere
  // 
  // NAVBAR_HEIGHT: 40,
  // NAVBAR_HEIGHT: 0.07,
  NAVBAR_HEIGHT: 0.07,
});

export default constants;
